import { render, staticRenderFns } from "./ServiceOrderItem.vue?vue&type=template&id=402cb6f2&scoped=true&"
import script from "./ServiceOrderItem.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderItem.vue?vue&type=style&index=0&id=402cb6f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402cb6f2",
  null
  
)

export default component.exports